<template>
  <div class="root-container">
    <van-notice-bar
      wrapable
      :scrollable="false"
      mode="closeable"
      text="提示：修改后的实际地址与用户下单地址的距离3公里，提交成功后，将通过短信方式提示您"
    />
    <div class="card card_old" v-if="false">
      <span>原服务地址</span>
      <van-divider />
      <span>{{ custAddress }}</span>
      <span>{{ cust }}</span>
    </div>
    <div class="card card_new">
      <span>新服务地址</span>
      <div class="address">
        <van-field
          class="input"
          v-model="text"
          placeholder="请输入小区楼栋/乡村名称"
          type="textarea"
          maxlength="100"
          show-word-limit
          @click-input="onClickInput"
        >
        </van-field>
        <div class="location" @click="onClickLocation">
          <van-icon
            :name="require('/static/img/icon_location.png')"
            size="11"
            color="#4a66f8"
          />
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button style="height: 46px" block color="#4a66f8" @click="onConfirm"
        >提交</van-button
      >
    </div>
    <router-view />
  </div>
</template>

<script>
import { NoticeBar, Toast, Dialog } from "vant";
import util from "@/utils/util";
import axios from "axios";
export default {
  components: {
    [NoticeBar.name]: NoticeBar,
  },
  data() {
    return {
      text: null,
      orderCode: null, //移动端传来的订单号
      cust: null, //移动端传来的客户名
      custAddress: null, //移动端传来的地址
      cityName: null, //用户当前城市名 -- xx市 用于poi搜索时锁定城市
      location: null, //用户当前定位 格式为 经度,纬度
    };
  },
  computed: {
    newAddress() {
      return this.$store.state.newAddress;
    },
    newLocation() {
      return this.$store.state.newLocation;
    },
  },
  mounted() {
    this.orderCode = util.getUrlKey("orderCode");
    this.cust = util.getUrlKey("deliveryCust");
    this.custAddress = util.getUrlKey("deliveryAddress");
    this.getAppLocation();
  },
  methods: {
    onConfirm() {
      //新增支持手输地址。如果选择的新地址与手输地址都为null，提示选择地址，有一项不为空则可以提交
      if ((!this.newAddress || !this.newLocation) && !this.text) {
        Toast("请选择地址");
        return;
      }
      Dialog.confirm({
        title: "修改提示",
        message:
          "修改后的实际地址与用户下单地址的距离3公里，提交成功后，将通过短信方式提示您",
        cancelButtonColor: "#666666",
        confirmButtonColor: "#4a66f8",
      })
        .then(() => {
          // on confirm
          this.saveOrderAddress();
        })
        .catch(() => {
          // on cancel
        });
    },
    //调用原生
    saveOrderAddress() {
      if (this.text != this.newAddress) {
        //不相等，说明1.地址选择后，有手动修改 2.没有选择地址，直接手输确定
        this.getLocationFromAddress(this.text); //根据修改后的地址获取经纬度
        return;
      }
      let that = this;
      this.$ckEvent.add("init", function () {
        let lng;
        let lat;
        if (that.newLocation && that.newLocation.includes(",")) {
          const arr = that.newLocation.split(",");
          if (arr.length === 2) {
            lng = arr[0];
            lat = arr[1];
          }
        }
        window.hdk.device.saveOrderAddress(
          that.orderCode,
          that.newAddress,
          lng,
          lat
        );
      });
    },
    getLocationFromAddress(address) {
      Toast.loading({
        message: "加载中",
        duration: 0,
      });
      const url = `https://restapi.amap.com/v3/geocode/geo?key=6657ce532af7e1ba869148dff59e8b35&city=${this.cityName}&address=${address}`;
      axios.get(url).then((res) => {
        console.log(res);
        Toast.clear();
        if (res.data && res.data.geocodes && res.data.geocodes.length > 0) {
          const obj = res.data.geocodes[0];
          //重新赋值
          this.cityName = obj.city;
          this.$store.commit("setNewAddress", address);
          this.$store.commit("setNewLocation", obj.location);
          //再次保存
          this.saveOrderAddress();
        } else {
          Toast("请输入正确地址");
        }
      });
    },
    //js交互取原生位置信息
    getAppLocation() {
      const that = this;
      this.$ckEvent.add("init", function () {
        window.hdk.device.getAppLocation(function (status, result) {
          if (status === "SUCCESS") {
            if (!result) {
              return;
            }
            const lng = result.longitude;
            const lat = result.latitude;
            that.cityName = result.city;
            that.location = `${lng},${lat}`;
          }
        });
      });
    },
    //输入框点击
    onClickInput() {
      // this.goChooseAddress();
    },
    //定位点击
    onClickLocation() {
      this.goChooseAddress();
    },
    goChooseAddress() {
      this.$router.push({
        name: "ChooseAddress",
        params: {
          cityName: this.cityName,
          location: this.location,
        },
      });
    },
  },
  watch: {
    newAddress: function (newValue, oldValue) {
      this.text = newValue;
    },
  },
};
</script>


<style lang="scss" scoped>
.root-container {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background: white;
}
.card {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px 19px;
}
.card_old {
  span:nth-of-type(1) {
    font-size: 16px;
    color: #333333;
  }
  span:nth-of-type(2) {
    font-size: 20px;
    font-weight: 500;
  }
  span:nth-of-type(3) {
    font-size: 14px;
    color: #333333;
    margin-top: 4px;
  }
}
.card_new {
  span:nth-of-type(1) {
    font-size: 15px;
    color: #333333;
  }
  .address {
    margin-top: 12px;
    position: relative;
    .location {
      position: absolute;
      top: 0;
      right: 0px;
      padding: 14px;
      display: flex;
    }
    .input {
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      ::v-deep .van-field__control {
        color: black;
        font-size: 14px;
      }
    }
    ::v-deep .van-cell {
      padding: 8px 7px 6px 10px;
    }
  }
}
.bottom {
  position: absolute;
  left: 13px;
  right: 13px;
  bottom: 13px;
}
</style>